import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { DividerModule } from 'primeng/divider'

@Component({
    selector: 'app-heading',
    imports: [CommonModule, DividerModule],
    templateUrl: './heading.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class Heading {
    type = input<'h1' | 'h2' | 'h3' | 'h4'>('h1')
    content = input<string>('')
    subheading = input<string>('')
    text = input<'left' | 'center' | 'right'>('left')
    divider = input<boolean>(false)
    additionalClasses = input<string>('')
}
